@let formData = model['planning-trip']; @let travelers = formData.travelers;
@let departDate = formData.range.from; @let returnDate = formData.range.to;

<div class="d-flex flex-column h-100 planning-trip">
  <div class="d-flex align-items-center justify-content-between planning-trip-header">
    <h1 class="semi-bold">{{ title }}</h1>
    <ds-button
      (click)="hideModal()"
      variant="icon"
      size="s"
      icon="xmark"
      label="Close"
      data-id="hide"
    />
  </div>
  <div class="d-flex flex-column p-6 planning-trip-body">
    <div class="d-flex flex-column planning-trip-body-header d-md-none">
      <div class="d-flex g-3 align-items-center">
        <ds-button
          (click)="hideModal()"
          variant="icon"
          size="s"
          icon="chevronLeft"
          label="Back"
          data-id="hide"
        />
        <h3 class="bold">{{ title }}</h3>
      </div>

      <lead-details-subtitle
        [departDate]="departDate"
        [returnDate]="returnDate"
        [travelers]="travelers"
      />
    </div>

    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" [model]="model" />
    </form>
  </div>
  <div class="d-flex planning-trip-action">
    <ds-button
      [disabled]="!form.valid"
      (click)="submit()"
      label="Get a quote"
      data-id="get-a-quote"
    />
  </div>
</div>
